<template>
  <div ref="container"
       :class="[ 'draggable-slider', { 'draggable-slider--padded': padded } ]"
       data-test-id="draggable-slider">
    <div class="draggable-slider__button">
      <Button v-if="state.showLeftButton"

              type="secondary"
              @click="move(-1)">
        <template #icon>
          <Icon name="arrow-left-line"/>
        </template>
      </Button>
    </div>
    <Swiper ref="slider"
            @slider-move="sliderMove"
            @real-index-change="realIndexChange"
            @swiper="initSwiper"
            :mousewheel="true"
            :modules="modules"
            slides-per-view="auto"
            :free-mode="{ enabled: true, momentumVelocityRatio: 2 }">
      <slot/>
    </Swiper>
    <div class="draggable-slider__button draggable-slider__button--right">
      <Button v-if="state.showRightButton"

              type="secondary"
              @click="move(1)">
        <template #icon>
          <Icon name="arrow-right-line"/>
        </template>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref } from 'vue'
import { FreeMode, Mousewheel } from 'swiper'
import { Swiper } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/mousewheel'
import Button from '@/components/partials/Buttons/Button/Button.vue'
import Icon from "@/components/partials/Icon.vue"

const modules = [ FreeMode, Mousewheel ]

const props = withDefaults(defineProps<{
  padded: boolean
  delta?: number
}>(), {
  delta: 3,
})

const container = ref(null)
const slider = ref(null)
// const draggable = ref(null)
const swiper = ref(null)

const state = reactive({
  showRightButton: false,
  showLeftButton: false,
})

const sliderContainerWidth = computed(() => container.value?.getBoundingClientRect().width)
const sliderWidth = computed(() => slider.value?.$el.scrollWidth)

function move(delta) {
  swiper.value?.slideTo(swiper.value?.realIndex + (delta * props.delta))

  state.showLeftButton = !swiper.value?.isBeginning
  state.showRightButton = !swiper.value?.isEnd
}

onMounted(async () => {
  if (sliderWidth.value > sliderContainerWidth.value) {
    state.showRightButton = true
  }
})

function initSwiper(s) {
  swiper.value = s
}

function sliderMove(swiper) {
  state.showLeftButton = !swiper.isBeginning
  state.showRightButton = !swiper.isEnd
}

function realIndexChange(swiper) {
  state.showLeftButton = !swiper.isBeginning
  state.showRightButton = !swiper.isEnd
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/breakpoints-up.scss";
@import "@/assets/css/mixins/styling.scss";

.draggable-slider {
  $self:    &;
  position: relative;
  user-select: none;
  margin:   0 auto;
  width:    100%;

  &__overflow {
    overflow: hidden;

    // @include lg-up {
    margin: 0;
    // }
  }

  &__slider {
    display:   flex;
    align-items: center;
    gap:       0.5rem;
    width:     max-content;
    min-width: 100%;
  }

  &__button {
    display: none;

    @include lg-up {
      display:  block;
      position: absolute;
      top:      50%;
      transform: translateY(-50%);
      left:     -1.5rem;
      z-index:  10;

      &--right {
        left: auto;
        right: -1.5rem;
      }
    }
  }

  &--padded {
    #{$self}__slider {
      padding: 1rem 0;
    }
  }
}
</style>
